// extracted by mini-css-extract-plugin
export default {"difficulty":"yW7LP","difficultyEasy":"ksHEM","icon":"ZaO8p","difficultyMedium":"TDzqN","difficultyHard":"DdFbU"};